import {useAuth} from 'app/modules/auth'
import LecturerDashboard from './LecturerDashboard'
import StudentDashboard from './StudentDashboard'
import AdminDashboard from './AdminDashboard'
import ParentDashboard from './ParentDashboard'
import OnlineStdDashboard from './OnlineStdDashboard'

const DashboardWrapper = () => {
  const {currentUser} = useAuth()
  const pos = currentUser?.position

  const firstRole = currentUser?.roles?.[0] || null

  if (firstRole === 'Lecturer') return <LecturerDashboard />
  else if (pos === 'Student') return <StudentDashboard />
  else if (pos === 'Online Student') return <OnlineStdDashboard />
  else if (currentUser?.position === 'Parent') return <ParentDashboard />
  else return <AdminDashboard />
}

export {DashboardWrapper}
